import type { JSX } from 'react'
import type { ITextBoxProps, TextAligning } from 'atoms/TextBox'
import type { ITextBlockProps } from '../TextBlock'

import { TextBox, TextBoxColors, TextBoxTypes } from 'atoms/TextBox'
import { TextBlock } from '../TextBlock'

export interface ITextBlockPopupMention extends ITextBlockProps {
  title: ITextBoxProps['title']
  description: ITextBoxProps['title']
  alignment?: TextAligning
}

export const TextBlockPopupMention = ({
  title,
  description,
  alignment,
  ...rest
}: ITextBlockPopupMention): JSX.Element => {
  return (
    <TextBlock {...rest}>
      <TextBox
        maxLines={2}
        font={TextBoxTypes.Headline3}
        color={TextBoxColors.TEXT_ICON_PRIMARY}
        alignment={alignment}
        title={title}
      />
      <TextBox
        maxLines={2}
        alignment={alignment}
        font={TextBoxTypes.Caption3}
        color={TextBoxColors.TEXT_ICON_SECONDARY}
        title={description}
      />
    </TextBlock>
  )
}
